(function() {
    'use strict';
    
a3_cabin_reports.factory('IncompleteServicesIssueFactory', IncompleteServicesIssueFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name IncompleteInFlightServicesFactory
    * @description 
    *   Manage Incomplete In-Flight Services Reasons.
    * @ngInject
    */
function IncompleteServicesIssueFactory(GenericModalFactory) {

		
		var service = {
            createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
        };
         /**
         * Initialiaze IncompleteService object 
         * @memberof IncompleteInFlightServicesFactory
         */
		function IncompleteService() {
			this.Id = null;
			this.ServiceClass = null;
			this.Rows = [];
            this.ServiceType = null;
            this.Reason = null;
            this.Remarks = null;

		}
			
        /**
         * Create new IncompleteService object 
         * @memberof IncompleteInFlightServicesFactory
         */
		function createNew() {
			var newObj = GenericModalFactory.createNew(IncompleteService);
            var RowSet = { From : null , To : null };
            newObj.Rows.push(RowSet);
      
            return newObj;
		}

        /**
         * Extend given IncompleteService object 
         * @memberof IncompleteInFlightServicesFactory
         * @param {object} obj The IncompleteService object that will be extended
         * @returns {object} IncompleteService
         */    
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,IncompleteService)
		}

        /**
         * Delete IncompleteService object from given list
         * @memberof IncompleteInFlightServicesFactory
         * @param {object} obj The IncompleteService object that will be deleted
         * @returns {array} IncompleteServices
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
	
        /**
         * Extend given IncompleteService object List 
         * @memberof IncompleteInFlightServicesFactory
         * @param {object} obj The IncompleteService object that will be extended
         * @returns {array} IncompleteServices
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,IncompleteService)
		}

		return service;
	}

})();